module.exports = __webpack_public_path__ + "static/icon-webdev-2562dbe113f25c14218e7bbfe00641a9.png";